import { render, staticRenderFns } from "./MainMenuSubmenu.vue?vue&type=template&id=5cb403f8&"
import script from "./MainMenuSubmenu.vue?vue&type=script&lang=js&"
export * from "./MainMenuSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports